import React, { useState, useEffect } from 'react'
import { Table, TableHead, TableBody, TableCell, TableContainer, TableRow } from '@mui/material'
import keywordManagement from '../../../../../services/keywordManagement.service'
import { LoaderDots } from '../../../../../components'
import { useGlobalStore } from '../../../../../store'
import { getObjectAsArray } from '../../../../../util'
import { GridWrapper, TableWrapper } from './style'

const Grid = () => {
  const [gridData, setGridData] = useState([])
  const [loader, setLoader] = useState(true)
  const { company } = useGlobalStore()

  const onload = async () => {
    setLoader(true)
    const payload = { organizationId: company?.OrganizationId }
    const response = await keywordManagement.getItemsAnalyzedPerKeywordCountApi(payload)
    const finalResp = getObjectAsArray(response)?.filter(f => f?.KeywordValue?.length > 0 && f?.ItemCount >= 0) || []
    setGridData(finalResp)
    setTimeout(() => {
      setLoader(false)
    }, 500)
  }

  useEffect(() => {
    onload()
  }, [company?.OrganizationId])

  return (
    <GridWrapper>
      <TableWrapper sx={{ width: '100%', mb: 2 }}>
        <TableContainer>
          {gridData?.length > 0 && <Table aria-labelledby='tableTitle' size='medium'>
            <TableHead>
              <TableRow>
                <TableCell>Keyword</TableCell>
                <TableCell>Count</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {gridData?.map((row, index) => {
                return (
                  <TableRow key={index}>
                    <TableCell>{row?.KeywordValue || '-'}</TableCell>
                    <TableCell>{row?.ItemCount || '-'}</TableCell>
                  </TableRow>
                )
              })}
            </TableBody>
          </Table>}

          {loader && <LoaderDots /> }
          {!loader && gridData?.length === 0 && (
            <Table>
              <TableRow>
                <TableCell>
                  No Data Found
                </TableCell>
              </TableRow>
            </Table>
          )}
        </TableContainer>
      </TableWrapper>
    </GridWrapper>
  )
}

export default Grid
